import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { style: {"margin-left":"21px"} }
const _hoisted_2 = { style: {"font-weight":"bold"} }
const _hoisted_3 = {
  key: 0,
  style: {"font-size":"14px","color":"gray","margin-top":"0"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-clock fa-fw" }, null, -1)
const _hoisted_5 = { style: {"color":"var(--color)"} }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fal fa-user-helmet-safety fa-fw" }, null, -1)
const _hoisted_7 = { style: {"padding-left":"22px"} }

import {
  IonContent, IonHeader, IonPage, IonButtons,
  IonTitle, IonBackButton, IonNote,
  IonToolbar, IonList, IonItem, IonLabel, IonSegment, IonSegmentButton
} from '@ionic/vue';
import { ref } from 'vue';
import EmptyState from './components/EmptyState.vue'
import ListSkeletton from './components/ListSkeletton.vue'
import dayjs from 'dayjs';
import { useAuthStore } from '@/stores/auth.store';
import { getApi } from '@/helpers/api';
import { PeriodAllocationsApi, DtoAllocation } from 'ppf-api-client';

//route parameters

export default /*#__PURE__*/_defineComponent({
  __name: 'AllocationsDayPage',
  props: {
  /**
   * day for which details should be displayed
   */
  start: String,
},
  setup(__props) {

const props = __props

const loading = ref(true);
const display = ref<'current' | 'previous' | 'next'>('current');
//the displayed allocation details
const map = ref<Map<number, DtoAllocation[]>>(new Map<number, DtoAllocation[]>());
//keep the map of current allocations so we don't have to query it again
let currentMap: Map<number, DtoAllocation[]> = new Map<number, DtoAllocation[]>();
//keep the line names indexed on id to be able to show the list headers
let lineNames: Map<number, [string, Date]> = new Map<number, [string, Date]>();

const service = getApi(PeriodAllocationsApi);
const auth = useAuthStore();

//load initial data
if (props.start && service) {
  const start = new Date(props.start);

  service.periodAllocationsGetDetails(auth.userId, start).then(r => {
    r.forEach(r1 => {
      if (r1.length > 0 && r1[0].lineId && r1[0].line && r1[0].start ) {
        lineNames.set(r1[0].lineId, [r1[0].line, r1[0].start]);
        currentMap.set(r1[0].lineId, r1); //keep it for later
        map.value.set(r1[0].lineId, r1);  //use it for view
      }
    });
    loading.value = false;
  });
}

/**
 * ion-segment change handler
 * @param e 
 */
const displayChanged = (e: any) => {
  display.value = e.target.value;

  //switch to 'current': just reload saved data from initial load
  if (display.value == 'current') {
    for (const key of currentMap.keys()) {
      if (currentMap.has(key)) {
        // eslint-disable-next-line
        map.value.set(key, currentMap.get(key)!);
      }
    }

  } else {
    if (props.start && service) {
      //switch to 'previous': get previous allocations for all lines up to current's start
      if (display.value == 'previous') {
        for (const entry of currentMap.entries()) { //entry: [0: key, 1: AllocationItem[]]
          if (entry[1].length >= 0) {
            //find the person with the earliest  start
            //Note: no need to get a particular item anymore
            const latest = entry[1][0]; //.reduce((acc, cur) => acc.start < cur.start ? acc : cur);
            if (!latest.lineId || !latest.shiftOccurenceId || !latest.start || !latest.end) {
              console.warn('Cannot retrieve detailed planning: missing information');
              continue;
            }
            service.periodAllocationsGetPlanningDetailBefore(latest.lineId, latest.shiftOccurenceId, latest.start, latest.end).then(r => {
              map.value.set(entry[0], r);
            });
          }
        }

        //switch to 'next': get next allocations for all lines after current's end
      } else if (display.value == 'next') {
        for (const entry of currentMap.entries()) { //entry: [0: key, 1: AllocationItem[]]
          if (entry[1].length >= 0) {
            //find the person with the latest end
            //Note: no need to get a particular item anymore
            const latest = entry[1][0]; //.reduce((acc, cur) => acc.start > cur.start ? acc : cur);
            if (!latest.lineId || !latest.shiftOccurenceId || !latest.start || !latest.end) {
              console.warn('Cannot retrieve detailed planning: missing information');
              continue;
            }
            service.periodAllocationsGetPlanningDetailAfter(latest.lineId, latest.shiftOccurenceId, latest.start, latest.end).then(r => {
              map.value.set(entry[0], r);
            });
          }
        }
      }
    }
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonHeader), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonToolbar), null, {
            default: _withCtx(() => [
              _createVNode(_unref(IonButtons), { slot: "start" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(IonBackButton), {
                    defaultHref: "/",
                    text: _ctx.$t('g.back')
                  }, null, 8, ["text"])
                ]),
                _: 1
              }),
              _createVNode(_unref(IonTitle), { style: {"text-transform":"capitalize"} }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(dayjs)(props.start).format('dddd D MMMM')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(IonContent), null, {
        default: _withCtx(() => [
          _createVNode(_unref(IonSegment), {
            value: display.value,
            onIonChange: displayChanged
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(IonSegmentButton), { value: "previous" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('g.previous')), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(IonSegmentButton), { value: "current" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('g.current')), 1)
                ]),
                _: 1
              }),
              _createVNode(_unref(IonSegmentButton), { value: "next" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('g.next')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["value"]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(map.value.entries(), ([key, allocations]) => {
            return (_openBlock(), _createElementBlock("div", { key: key }, [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("h5", _hoisted_2, _toDisplayString(_unref(lineNames).get(key) ? _unref(lineNames).get(key)![0] : ''), 1),
                (allocations.length > 0)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_3, [
                      _hoisted_4,
                      _createTextVNode(" " + _toDisplayString(_unref(dayjs)(allocations[0].start).format('L')) + " " + _toDisplayString(allocations[0].time), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createVNode(_unref(IonList), null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allocations, (c, idx) => {
                    return (_openBlock(), _createBlock(_unref(IonItem), { key: idx }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(IonLabel), null, {
                          default: _withCtx(() => [
                            _createElementVNode("p", _hoisted_5, [
                              _hoisted_6,
                              _createTextVNode(" " + _toDisplayString(c.name), 1)
                            ]),
                            _createElementVNode("p", _hoisted_7, _toDisplayString(c.userName) + " (" + _toDisplayString(_unref(dayjs)(c.start).format('LT')) + " - " + _toDisplayString(_unref(dayjs)(c.end).format('LT')) + ")", 1)
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024))
                  }), 128)),
                  (allocations.length <= 0)
                    ? (_openBlock(), _createBlock(_unref(IonItem), { key: 0 }, {
                        default: _withCtx(() => [
                          _createVNode(_unref(IonNote), null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('p.allocation-day.line-empty')), 1)
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024)
            ]))
          }), 128)),
          _createVNode(ListSkeletton, {
            style: _normalizeStyle({ display: loading.value ? 'block' : 'none' })
          }, null, 8, ["style"]),
          _createVNode(EmptyState, {
            style: _normalizeStyle({ display: loading.value || map.value.size > 0 ? 'none' : 'block' }),
            icon: "fa-user-helmet-safety"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('p.allocation-day.empty')), 1)
            ]),
            _: 1
          }, 8, ["style"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})